.alert.cookie-message {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: $zindex-fixed;
	background-color: $cookieBG;
	color: $cookieText;
	@include text-size(14);
	@include line-height(20);

	.container-fluid {
		display: flex;
		align-items: center;
	}
	&.has-icon {
		.alert-icon {
			position: relative;
			margin-right: 24px;
			display: flex;
			align-items: center;
			width: 30px;
			height: 30px;

			svg {
				@include svg-format(30px, 30px, $cookieIcon);
			}
			img {
				width: 100%;
				height: 100%;
				max-width: 30px;
				max-height: 30px;
				filter: $cookieIconFilter;
			}
		}
	}
	p:last-of-type { padding-bottom: 0; }
	.arrow-link__underline--animate {
		color: $primary;
		border-color: $primary;

		span {
			color: $primary;

			.svg-icon * {
				color: $primary;
				fill: $primary !important;
			}
		}
	}
	a {
		color: $cookieText;
	}
}

.kdx-cookie {
	background-color: $cookieBG;
	box-shadow: 0px -4px 14px rgba(0, 37, 64, 0.10);

	> .container, > .container-fluid {
		display: flex;
		justify-content: space-between;
		align-items: center;
		justify-content: center;

		img{
			max-width: 115px;
			margin: 0 10px;
		}

		> * {
			padding: 0 $gutter-def;
			flex: 1 0 auto;
			font-size: 16;

			&:nth-child(2) {
				padding-left: 0;
				max-width: 75%;
			}

			&:last-child {
				padding-right: 0;
				text-align: center;
			}
		}
	}

	p {
		margin: 0;
		padding: 0;
		color: #282828;
	}

	.cookie-links {
		@include row-cols(1);
		max-width: 250px;

		[class^="arrow-link"] {
			padding: 0;
			width: auto;

			.svg-icon {
				border-bottom: solid 1px $primary;
				margin: 0 0 0 5px;
				bottom: -1px;

				svg {
					margin: 0 0 1px;
				}
			}
		}

		> :first-child {
			margin: 0 0 10px;
		}
	}
}






@include media-breakpoint-down(md) {
	.alert.cookie-message {
		.container, .container-fluid {
			flex-direction: column;	
			text-align: center;		

			> * {
				padding: 0;
			}

			p {
				max-width: 100%;
			}
			.alert-icon {
				margin-bottom: 16px;
				margin-right: 0;
			}
			img {
				max-width: 60px;
				margin-bottom: 10px;
			}
			.cookie-links { 
				margin: 24px auto 0 auto;
			}
		}
	}

	.kdx-cookie {
		> .container, .container-fluid {
			flex-direction: column;
			padding: 0 35px;
		}

		.cookie-links {
			padding: 0;
			margin: 20px 0 0;

			> :first-child { 
				margin: 0 0 20px 0;
			}
		}
	}
}





@include media-breakpoint-down(sm) {
	.alert {

		.cookie-links {
			width: 80%;
			margin: 0 auto;
			
			.btn { 
				width: 100%;
				justify-content: center;
			}
		}
	}
}